<template>
  <div
    v-if="vehicle"
    class="wrapper"
  >
    <div class="left">
      <vehicle-capacities :vehicle="vehicle" />
      <div class="img-wrapper">
        <img
          v-if="vehicle.images"
          :src="vehicle.images.high"
          :alt="vehicle.label"
        >
      </div>
      <a
        v-if="promoEnabled"
        class="promo-banner"
        :href="vehicle.promotion.url"
        :style="'background-color:' + vehicle.promotion.color"
        :target="vehicle.promotion.url_target == 1 ? '_blank ': '_self'"
      >{{ vehicle.promotion.label }}</a>
    </div>
    <div class="right">
      <div class="r-section">
        <a
          href="/vehicules?changer_vehicule"
          aria-label="modifier"
        >
          <svg>
            <use xlink:href="#icon-pencil"></use>
          </svg>
        </a>
        <h2>{{ $t('commons.vehicule') }}</h2>
        {{ vehicle.label }}
        <div
          v-if="vehicle.rrs_category"
          class="category"
        >
          {{ $t('commons.category_abbrev') }} {{ vehicle.rrs_category.label }}
        </div>
        <vehicle-availability
          v-if="!degraded"
          :vehicle="vehicle"
          :payment="usePayment"
        />
      </div>
      <div class="r-section">
        <a
          href="/vehicules?changer_date"
          aria-label="modifier"
        >
          <svg>
            <use xlink:href="#icon-pencil"></use>
          </svg>
        </a>
        <h2>{{ $t('commons.dates') }}</h2>
        <h3>{{ $t('commons.departure') }}&nbsp;:</h3>
        <div>{{ pickUpMessage }}</div>
        <h3>{{ $t('commons.return') }}&nbsp;:</h3>
        <div>{{ dropMessage }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import format from 'date-fns/format'
import VehicleCapacities from '../shared/vehicleElements/VehicleCapacities';
import vehicleCard from '../shared/mixins/vehicleCards'

export default {
  name: 'QuotationVehicle',
  mixins: [vehicleCard],
  components: {
    VehicleCapacities,
    VehicleAvailability: () => import(/* webpackChunkName: "availability"  */ `../shared/vehicleElements/VehicleAvailability`),
  },
  props: {
    degraded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    vehicle() {
      return this.$store.state.vehicles.set.storeVehicle;
    },
    pickUpMessage() {
      const pickUpDate = localStorage.getItem('rentPickupDate')
      const pickUpTime = localStorage.getItem('rentPickupTime')
      return `${format(new Date(pickUpDate), 'dd/MM/yyyy')} à ${pickUpTime}`
    },
    dropMessage() {
      const dropDate = localStorage.getItem('rentDropDate')
      const dropTime = localStorage.getItem('rentDropTime')
      return `${format(new Date(dropDate), 'dd/MM/yyyy')} à ${dropTime}`
    },
  },
  mounted() {
    this.$store.dispatch('vehicles/GET_VEHICLE_LIST');
  },
};
</script>
<style lang="scss" scoped>

.wrapper {
  width: 100%;

  @include teq-breakpoint($large) {
    align-self: stretch;
    display: flex;
  }
}

.left {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 20px;
  position: relative;
  width: 100%;

  @include teq-breakpoint($large) {
    width: 55%;
  }
}

.img-wrapper {
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
}

img {
  height: initial;
  max-width: 100%;
  width: 323px;
}

.right {
  background: $c-alabaster;
  display: flex;
  flex-direction: column;
  width: 100%;

  @include font-size(14);

  @include teq-breakpoint($large) {
    width: 45%;
  }
}

.category {
  margin: 0 0 15px;
}

.r-section {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  padding: 20px;
  position: relative;

  & + & {
    border-top: 1px solid $c-alto;
  }
}

a {
  position: absolute;
  right: 15px;
  top: 15px;
}

svg {
  height: 15px;
  width: 15px;
}

h3 {
  @include font-size(14);

  font-family: $f-graphie-bold;

  div + & {
    margin: 15px 0 0;
  }
}

h2 {
  font-family: $f-graphie-bold;
  font-weight: 600;
  margin: 0;
  text-align: left;
  text-transform: none;

  @include font-size(20px);
}

.promo-banner {
  background: #fc3;
  bottom: 30px;
  color: #201906;
  left: -45px;
  line-height: 1;
  padding: 6px 30px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  top: auto;
  -webkit-transform: perspective(1px) rotate(45deg);
  transform: perspective(1px) rotate(45deg);
  width: 180px;

  @include font-size(13px);

  &:hover {
    color: white;
  }
}
</style>
